import React from "react";
import Card from "../Card"
import DonutChart from '../DonutChart';
import DropdownOptions from "../DropdownOptions";
import i18n from "i18n";
import styles from "./MainApp.organisms.Dashboard.OrderStatesCard.module.scss";
import { capitalize } from "helpers/utils/utils_general";

const options = [
  {
    key: "all",
    value: i18n.t("all.f"),
  },
  {
    key: "REQ",
    value: i18n.t("orders.types.REQ"),
  },
  {
    key: "PRE",
    value:  i18n.t("orders.types.PRE"),
  },
  {
    key: "REC",
    value: i18n.t("orders.types.REC"),
  },
  {
    key: "REL",
    value: i18n.t("orders.types.REL"),
  },
];


const OrderStatesCard = ({series, colors, totalNumber, handleChangeFilter}) => {
  return (
    <div className={styles["delivered-orders-card-container"]}>
      <Card>
        <div className={styles["title-container"]}>
          <h1 className={styles["dashboard-card-title"]}>{i18n.t("order.status.last.30.days")}</h1>
          <DropdownOptions
            options={options}
            selectedOption={'all'}
            label={i18n.t("order.type")}
            handleChange={handleChangeFilter}
          />
        </div>

        <div className={styles["most-selled-table"]}>
          <DonutChart series={series} colors={colors} totalNumber={totalNumber} itemName={capitalize(i18n.t("orders"))}/>
        </div>
      </Card>
    </div>
  );
};

export default OrderStatesCard;
